module.exports = __webpack_public_path__ + "Tinebase/js/ace-mode-perl6-FAT.js";